export const EXPORT_STATISTICS_GROUPS = 'EXPORT_STATISTICS_GROUPS';
export const LOAD_STATISTICS_EXPORTS = 'LOAD_STATISTICS_EXPORTS';
export const SET_STATISTICS_EXPORTS_PAGINATION = 'SET_STATISTICS_EXPORTS_PAGINATION';
export const LOAD_STATISTICS_GROUPS = 'LOAD_STATISTICS_GROUPS';
export const LOAD_STATISTICS_INVOICE = 'LOAD_STATISTICS_INVOICE';
export const SET_STATISTICS_INVOICE_PAGINATION = 'SET_STATISTICS_INVOICE_PAGINATION';
export const LOAD_STATISTICS_INVOICE_ORDERS = 'LOAD_STATISTICS_INVOICE_ORDERS';
export const SET_STATISTICS_INVOICE_SORT = 'SET_STATISTICS_INVOICE_SORT';
export const SET_STATISTICS_INVOICE_FILTERS = 'SET_STATISTICS_INVOICE_FILTERS';
export const RESET_STATISTICS_INVOICE_FILTERS = 'RESET_STATISTICS_INVOICE_FILTERS';
export const EXPORT_INVOICES = 'EXPORT_INVOICES';
